import {useEffect, useState} from "react";

function News (props) {

    const [news, setNews] = useState([]);

    const ticker = props.ticker;
  
    function fetchNews(url)  {
    
        const abortCtrl   = new AbortController();
    
        const fetchData= async () => {
              console.log("fetching news... "); 
              try {
                  const response = await fetch(url,{signal: abortCtrl.signal});
                  const json = await response.json();
                  setNews(json.feed);
                  console.log("done fetching news items");  
              } catch (error) {
                  if (error.name === 'AbortError'){
                      console.log("aborted: ", error);
                  }
                  else {
                      console.log("error: ", error);
                  }
              }
        };
      
        fetchData();
      
        return () => abortCtrl.abort();
      }


      useEffect(() => {

        const server="https://app.cuetraders.com";
        let url = server+"/api/load_news.php?tickers="+ticker;
        fetchNews(url);
    
      }, [ticker]);

      return (<div className="News"> {news &&
        <div className="col-lg-10 col-sm-10 col-xs-12">
        <h4>Headlines</h4> 
          <div className="col-lg-12 col-sm-12 col-xs-12">
                {news.map((item, idx)=> ( 
                    <div key={idx}>
                    <div className="h5"><a className="latest-news-title" href={item.url}> {item.title} </a></div>
                    <br></br>
                    <ul>
                    <li><i className="fa news"></i> <i className="latest-news-description">{item.summary}</i></li>
                    <li><i className="fa news">{item.source}</i> </li>
                    <li><i className="latest-news-date">{Date(item.time_published)}</i></li>
                    </ul>
                    <br></br>
                    </div>
                ))
                }
          </div>
    </div>}
    </div>)
}

export default News;